export interface ApiError extends Error {
  statusCode?: number
}

export const isDentalMaintenanceError = (error: ApiError | null) => error?.statusCode === 504
